export function tabs() {
    document.addEventListener('DOMContentLoaded', function () {
        const tabGroups = document.querySelectorAll('[data-tab-group]'); // 各タブグループを取得

        tabGroups.forEach((group) => {
            const buttons = group.querySelectorAll('.js-tab-btn');
            const tabs = group.querySelectorAll('.js-tab-content-inner');

            // 初期表示: グループ内の最初のタブを表示し、最初のボタンに -active クラスを追加
            tabs.forEach((tab) => (tab.style.display = 'none'));
            if (tabs.length > 0) {
                tabs[0].style.display = 'block'; // グループ内の最初のタブを表示
                buttons[0].classList.add('-active'); // グループ内の最初のボタンに -active クラスを追加
            }

            buttons.forEach((button) => {
                button.addEventListener('click', function () {
                    const targetTab = this.getAttribute('data-tab'); // ボタンの data-tab 属性を取得

                    // グループ内のすべてのタブを非表示にする
                    tabs.forEach((tab) => {
                        if (tab.getAttribute('data-tab') === targetTab) {
                            tab.style.display = 'block'; // 対応するタブを表示
                        } else {
                            tab.style.display = 'none'; // それ以外は非表示
                        }
                    });

                    // グループ内のすべてのボタンから -active クラスを削除
                    buttons.forEach((btn) => btn.classList.remove('-active'));

                    // クリックされたボタンに -active クラスを追加
                    this.classList.add('-active');
                });
            });
        });

        // get url query
        const url = new URL(window.location.href);
        const tab = url.searchParams.get('tab');
        
        if (tab) {
            const tabButton = document.querySelector(`.js-tab-btn[data-tab="${tab}"]`);

            if (tabButton) {
                tabButton.click();
            }
        }
    });
}
